export default {
  components: {
    hotLoading: () => import('~/components/Organisms/Loading/Loading.vue'),
  },

  props: {
    hasLogo: {
      type: Boolean,
      default: true,
    },

    hasBackground: {
      type: Boolean,
      default: false,
    },

    hasCheckbox: {
      type: Boolean,
      default: true,
    },

    noTransform: {
      type: Boolean,
      default: false,
    },

    locale: {
      type: String,
    },

    route: {
      type: Object,
    },

    element: {
      type: String,
    },

    isModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      url: process.env.BASE_URL,
      loading: true,
      iframeSrc: 'about:blank',
    }
  },

  computed: {
    isHomepage() {
      return Boolean(this.route.name && this.route.name.includes('index'))
    },

    isTestSignupEmbedButton() {
      if (
        this.$route.name === 'lp-producer___pt-br' &&
        this.$growthbook.isOn('243_corporate_website_home_all_devices_brazil_button_color_sign_embed')
      ) {
        return '&isSignupButtonOrange'
      }

      return ''
    },

    hostname() {
      const urlObject = new URL(this.url)
      if (process.env.ENVIROMENT === 'development') {
        return 'buildstaging.com'
      }

      return urlObject.hostname
    },

    service() {
      if (this.url === 'https://hotmart.com') {
        return 'https://app.hotmart.com/'
      }

      return 'https://app.buildstaging.com/'
    },

    path() {
      return this.route.path
    },

    logo() {
      return this.hasLogo ? '' : 'nologo'
    },

    transparent() {
      return this.hasBackground ? '' : 'transparent'
    },

    checkbox() {
      return this.hasCheckbox ? '' : 'nocheckbox'
    },

    query() {
      return Object.keys(this.route.query)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.route.query[key])}`)
        .join('&')
    },

    isTestLoginActivated() {
      const localizedExperiment = {
        es: () => !this.$growthbook.isOn('10_corporate_website_home_desktop_spain_login_social'),
        'es-mx': () => !this.$growthbook.isOn('11_corporate_website_home_desktop_mexico_login_social'),
        'es-co': () => !this.$growthbook.isOn('12_corporate_website_home_desktop_colombia_login_social'),
      }

      if (localizedExperiment[this.$i18n.locale]) {
        return localizedExperiment[this.$i18n.locale]()
      }

      return false
    },

    loginSocialClass() {
      if (!this.isTestLoginActivated) {
        return 'signup-iframe--loginSocial'
      }

      return ''
    },

    loginSocialFormated() {
      if (!this.isTestLoginActivated) {
        return '&loginSocial&nocheckbox'
      }

      return ''
    },
  },

  methods: {
    iframeLoaded() {
      this.loading = false
    },
  },
}
